import {DEFAULT_LOCALE_ISO, Messages} from "./Messages";

export class NullMessages implements Messages {
    readonly locale: string = DEFAULT_LOCALE_ISO;

    has(_key: string): boolean {
        return false; // never found
    }

    prop(key: string, ..._args: unknown[]): string {
        // this is the same behaviour as if the string is missing;
        return "[" + key + "]";
    }
}
